module.exports = __webpack_public_path__ + "static/media/i-letter.04665ad9.svg";